<script setup>
defineProps({
  title: String
});
</script>

<template>
  <div class="form-group">
    <div class="form-group__title">{{ title }}</div>
    <div class="form-group__items">
      <slot></slot>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.form-group {
  margin-bottom: 25px;

  &:last-child {
    margin-bottom: 0;
  }

  &__title {
    margin: 25px 0;
    color: #000;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: Lato, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }

  .form-input {
    margin: 0 0 25px !important;
  }

  &__items {
    display: flex;
    flex-direction: column;
    gap: 22px;
    background: inherit;
  }
}
</style>
